import { render, staticRenderFns } from "./Bpjs.vue?vue&type=template&id=168053a2&scoped=true"
import script from "./Bpjs.vue?vue&type=script&lang=js"
export * from "./Bpjs.vue?vue&type=script&lang=js"
import style0 from "./Bpjs.vue?vue&type=style&index=0&id=168053a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168053a2",
  null
  
)

export default component.exports